import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/large-logo.png'
import _imports_1 from '@/assets/img/bg.png'
import _imports_2 from '@/assets/img/top_menu_bg.png'
import _imports_3 from '@/assets/img/top_button_1.png'
import _imports_4 from '@/assets/img/top_button_2.png'
import _imports_5 from '@/assets/img/top_button_3.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0c457003")

_pushScopeId("data-v-0c457003")
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "bg-img" }
const _hoisted_3 = {
  key: 0,
  class: "info"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_5 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Footer = _resolveComponent("Footer")
  const _component_Questionnaire = _resolveComponent("Questionnaire")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _imports_0,
        width: "687",
        class: ["top-logo", { 'top-filling-info-space': _ctx.isNotEmptyMessage }]
      }, null, 2),
      _createVNode("img", {
        src: _imports_1,
        width: "1366",
        class: ["top-bg", { 'top-filling-info-space': _ctx.isNotEmptyMessage }]
      }, null, 2),
      _createVNode("img", {
        src: _imports_2,
        width: "1210",
        class: ["top-menu-bg", { 'top-filling-info-space': _ctx.isNotEmptyMessage }]
      }, null, 2),
      _createVNode("img", {
        src: _ctx.bgText,
        width: "560",
        class: ["top-bg-text", { 'top-filling-info-space': _ctx.isNotEmptyMessage }]
      }, null, 10, ["src"]),
      (_ctx.isNotEmptyMessage)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messages, (msg, i) => {
              return (_openBlock(), _createBlock("p", { key: i }, _toDisplayString(msg), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: ["start-commands", { 'top-filling-info-space': _ctx.isNotEmptyMessage }]
      }, [
        _createVNode("button", {
          class: "command",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openQuestionnaire && _ctx.openQuestionnaire(...args)))
        }, [
          _hoisted_4
        ]),
        _createVNode("button", {
          class: "command",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toTemplateList && _ctx.toTemplateList(...args)))
        }, [
          _hoisted_5
        ]),
        _createVNode("button", {
          class: "command",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toSampleDataList && _ctx.toSampleDataList(...args)))
        }, [
          _hoisted_6
        ])
      ], 2),
      _createVNode("footer", null, [
        _createVNode(_component_Footer)
      ])
    ]),
    _createVNode(_component_Questionnaire, {
      isShowModal: _ctx.isShowModal,
      "onUpdate:isShowModal": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowModal = $event))
    }, null, 8, ["isShowModal"])
  ]))
})